import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { AdminGuardGuard } from './admin/admin-guard.guard';
import { AuthGuard } from './auth-module/auth.guard';
import { AdminListComponent } from './admin/admin-list/admin-list.component';
import { AdminGuard } from './auth-module/admin.guard';


const routes: Routes = [
  { path: '',
    redirectTo: 'home',
    pathMatch: 'full' },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard],
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
